import axios from 'axios'
import {useQuery} from 'react-query'
import {ParamsModel} from 'src/app/modules/common/Model'
import {IProvince} from './province'
import {API_URL} from 'src/cms/constants/EndPoint'

const BRANCHES_API = `${API_URL}/branch/list`

interface IBranch {
  id: string
  title: string
  code_id: string
  code: string
  latitude: string
  longitude: string
  province: IProvince
}

const fetchBranchOptions = async (provinceId: string) => {
  try {
    // const provinceArray = {provinceCodeArray: provinceId?.map((item: number) => ({code: item}))}
    const {data} = await axios.get(`${BRANCHES_API}`, {
      params: {
        provinceId,
      },
    })

    const branches = data?.data?.branch?.map((item: IBranch) => ({
      label: item?.title,
      value: item?.id,
    }))

    const branchesWithAllOption = [{label: 'ALL BRANCHES', value: 'all'}, ...branches]
    return branchesWithAllOption
  } catch (error: any) {
    throw new Error(`Error fetching branch : ${error.message}`)
  }
}

const useGetBranchById = (provinceId: string) => {
  return useQuery(['getBranchById', provinceId], () => {
    if (provinceId) {
      return fetchBranchOptions(provinceId)
    }
  })
}

export default useGetBranchById

/**
 * All enabled branches as {label, value} options — no province needed. Used by list filters
 * that offer a plain branch dropdown. The branch list rarely changes, so it is cached.
 */
export const useGetAllBranchOptions = () => {
  return useQuery(
    ['getAllBranchOptions'],
    async () => {
      const {data} = await axios.get(BRANCHES_API)

      return (
        data?.data?.branch?.map((item: IBranch) => ({
          label: item?.title,
          value: item?.id,
        })) ?? []
      )
    },
    {
      staleTime: 5 * 60 * 1000,
      onError: (error) => {
        console.error('Error fetching branches:', error)
      },
    }
  )
}

interface IParams {
  search: string
  page?: number
  limit?: number
  orderBy: string
  order: string
}
const BRANCHES_API_List = `${API_URL}/branch`

export const useGetBranch = (params: IParams) => {
  return useQuery(
    ['getBranch', params],
    async () => {
      const {data} = await axios.get(BRANCHES_API_List, {params})

      // const branches = data?.branch?.map((item: any) => ({
      //   label: item?.title,
      //   value: item?.id,
      // }))
      return data
    },
    {
      onError: (error) => {
        console.error('Error fetching branch:', error)
      },
    }
  )
}
